import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../../Utils/Enums";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../../Components/Reusable/ButtonWithIcon";
import Image from "../../../Components/Reusable/Image";
import ConfirmationModal from "../../../Components/modal/ConfirmationModal";
import generatePaginationFooter from "../../../Components/Reusable/CustomPagination";
import RoutesPath from "../../../Utils/RoutesPath";
import { Link, useNavigate } from "react-router-dom";
import { handleApiErrors } from "../../../Utils/Utils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, validationRegex } from "../../../Utils/Utils";
import * as yup from "yup";
import CoordinatorService from "../../../Services/CoordinatorService";
import DynamicService from "../../../Services/DynamicService";
import FormModal from "../../../Components/modal/FormModal";
import CustomTextField from "../../../Components/Reusable/CustomTextField";
import SubAdminService from "../../../Services/SubAdmin";
import CustomDropDown from "../../../Components/Reusable/CustomDropDown";
import DataProvider from "../../../Utils/DataProvider";
import { AuthContext } from "../../../Context/authContext";

const RolesList = () => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const [studyMaterial, setStudyMaterial] = useState({});
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const navigate = useNavigate();

  const stepOneValidations = yup.object().shape({
    role: validationRegex.required,
  });

  const {
    register: registerStepOne,
    handleSubmit: handleSubmitStepOne,
    setValue: setValuesStepOne,
    formState: { errors: errorsStepOne },
    watch: watchStepOne,
    getValues: getValuesStepOne,
    reset: resetStepOne,
  } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      role: "",
    },
  });
  const {
    register: registerEdit,
    handleSubmit: handleSubmitEdit,
    formState: { errors: errorsEdit },
    reset: resetEdit,
    setValue: setEditValues,
  } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      role: "",
    },
  });
  const getAllRoles = async () => {
    try {
      const response = await SubAdminService.getAllRoles(
        offset,
        limit,
        searchQuery || ""
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    getAllRoles();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        getAllRoles();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  const ChangeStatus = async (id, status) => {
    try {
      await SubAdminService.updateRoleStatus(id, status);
      toast.success("Role Status Updated successfully");
      var updatedData = data;
      updatedData[updatedData.findIndex((item) => item._id === id)].is_active =
        status;
      setData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteSingleRole = async (id) => {
    try {
      await SubAdminService.deleteRole([id]);
      toast.success("Role Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      getAllRoles();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleCoordinators = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item._id);
          }
        });
      }
      await SubAdminService.deleteRole(itemsToDelete);
      toast.success("Roles Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      getAllRoles();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  const handleOpenAddModal = () => {
    resetStepOne(); // Reset form fields when opening Add modal
    setShowAddModal(true);
  };

  const addRole = async (data) => {
    console.log(data, "data");

    try {
      await SubAdminService.addRole({
        roleName: data.role,
        role_type: editData.role_type ? editData.role_type : 1,
      });
      setShowAddModal(false);
      setShowEditModal(false);
      toast.success(
        editData && editData._id
          ? "Role Updated Successfully"
          : "Role added successfully"
      );
      getAllRoles();
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const editRole = async (data) => {
    console.log(data, "data");

    try {
      await SubAdminService.addRole({
        role_id: editData._id,
        roleName: data.role,
        role_type: editData.role_type,
      });
      setShowAddModal(false);
      setShowEditModal(false);
      toast.success(
        editData && editData._id
          ? "Role Updated Successfully"
          : "Role added successfully"
      );
      getAllRoles();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const handleOpenEditModal = (item) => {
    setEditValues("role", item.roleName);
    setEditData(item);
    setShowEditModal(true);
  };
  return (
    <div>
      <div className="content" data-number="1">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">ROLES</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">Role List</h4>
          </div>
        </div>

        <div className="table_container" style={{ display: "block" }}>
          <h1 className="black fs-18 fw-600 mb-0">Role List</h1>

          <div className="table_title">
            <div className="table_headings mt-2 Commonclass">
              <h1 className="black fs-18 fw-600 mb-0">
                <div
                  className="table_delete_icon"
                  style={{
                    opacity:
                      data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                  }}
                  onClick={() => {
                    if (!(data.findIndex((item) => item.isChecked) == -1)) {
                      setIsMultipleDelete(true);
                      setShowDeleteModal(true);
                    }
                  }}
                >
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>

              <div className="d-flex gap-4 align-items-center Responsivesection">
                <div className="position-relative">
                  <input
                    type="search"
                    className="search_box search_bar"
                    placeholder="Search roles"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <Image
                    src={SvgImages.search}
                    style={ImageFilters.gray}
                    className="search_icon"
                    alt="Search Icon"
                    height="20px"
                  />
                </div>

                <ButtonWithIcon
                  text={"Add Role"}
                  icon={SvgImages.plus}
                  onClick={handleOpenAddModal}
                />
              </div>
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0"
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Role Name
                  </th>
                  <th
                    className="text-center"
                    scope="col"
                    style={{ width: "15%" }}
                  >
                    Current Status
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked = value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td>{item.roleName}</td>

                    <td className="text-center">
                      <label
                        className="switch"
                        data-bs-target="#change_status"
                        data-bs-toggle="modal"
                      >
                        <input
                          type="checkbox"
                          checked={item.is_active}
                          onChange={() => {
                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>

                    <td>
                      <div className="d-flex gap_8">
                        <a
                          className="d-flex justify-content-center align-items-center cursor-pointer"
                          onClick={() => {
                            navigate(
                              `${RoutesPath.setprivileges}/${item._id}`,
                              {
                                state: item,
                              }
                            );
                          }}
                        >
                          Set Privileges
                        </a>
                        <a
                          onClick={() => handleOpenEditModal(item)}
                          className="edit_icons cursor-pointer"
                          data-bs-target="#editclass"
                          data-bs-toggle="modal"
                        >
                          <Image
                            src={SvgImages.edit}
                            style={ImageFilters.green}
                            className="add_icons"
                            alt="Edit Icon"
                          />
                        </a>
                        <a
                          className="delete_icons cursor-pointer"
                          onClick={() => {
                            setDeleteId(item._id);
                            setIsMultipleDelete(false);
                            setShowDeleteModal(true);
                          }}
                        >
                          <Image
                            src={SvgImages.deleteIcon}
                            style={ImageFilters.red}
                            data-bs-target="#delete-modal"
                            data-bs-toggle="modal"
                            alt="Delete Icon"
                          />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {generatePaginationFooter(
            availableDataCount,
            limit,
            offset,
            setOffset
          )}
        </div>
      </div>
      {/* Add Role Modal */}
      <FormModal
        title={"Add Role"}
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        submitClickAction={handleSubmitStepOne(addRole)}
        children={
          <form onSubmit={handleSubmitStepOne(addRole)}>
            <CustomTextField
              labelTitle="Role Name"
              placeholder="Enter Role Name"
              name="role"
              id="role"
              showError={errorsStepOne?.role}
              errorMessage={errorsStepOne?.role?.message}
              register={registerStepOne}
              additionalClasses="profile_edit"
              showMandatory={true}
            />

            {/* Custom Text Field for Class */}
            {/* <CustomDropDown
              labelTitle="Role"
              placeholder="Enter role"
              name="role"
              id="role"
              setValue={setValuesStepOne}
              showError={errorsStepOne?.role}
              errorMessage={errorsStepOne?.role?.message}
              register={registerStepOne}
              additionalClasses="profile_edit"
              showMandatory={true}
              options={DataProvider.roles}
            /> */}
          </form>
        }
      />
      {/* Edit Role Modal */}
      <FormModal
        title={"Edit Role"}
        showModal={showEditModal}
        submitButtonText="Update"
        submitButtonIcon={SvgImages.tick_mark}
        setShowModal={setShowEditModal}
        submitClickAction={handleSubmitEdit(editRole)}
        children={
          <form onSubmit={handleSubmitEdit(editRole)}>
            {/* Custom Text Field for Class */}
            <CustomTextField
              labelTitle="Role"
              placeholder="Enter role"
              name="role"
              id="role"
              setValue={setEditValues}
              showError={errorsEdit?.role}
              errorMessage={errorsEdit?.role?.message}
              register={registerEdit}
              additionalClasses="profile_edit"
              showMandatory={true}
              //   options={DataProvider.roles}
              //   defaultOption={() => {
              //     setEditValues("role", editData.roleName, {
              //       shouldValidate: true,
              //     });
              //     return { value: editData.roleName, label: editData.roleName };
              //   }}
            />
          </form>
        }
      />
      {/* Delete Study Material Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Roles?"
            : "Are you sure want to delete this Role?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleCoordinators()
            : deleteSingleRole(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change Study Material Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(getStatusChangeData._id, !getStatusChangeData.is_active);
        }}
        theme={ConfirmationModalTheme.warning}
      />
    </div>
  );
};

export default RolesList;
